import { ArrowRight, ClipboardCheck, LockKeyhole } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'
import { ASSESSMENTS } from '../../data/dashboardData'

export function AssessmentsPage() {
  const navigate = useNavigate()

  return (
    <div className="content-page">
      <PageHeader
        title="题库与测评"
        description="先建立入学基线，再按单元和阶段验证真实掌握。"
      />

      <section className="assessment-list" aria-label="测评列表">
        {ASSESSMENTS.map((assessment) => {
          const isLocked = assessment.status === '未解锁'
          return (
            <article key={assessment.id} className="assessment-row">
              <span className="assessment-row__icon" aria-hidden="true">
                {isLocked ? <LockKeyhole size={21} /> : <ClipboardCheck size={21} />}
              </span>
              <div className="assessment-row__copy">
                <h2>{assessment.name}</h2>
                <p>{assessment.scope}</p>
              </div>
              <span className="assessment-row__duration">{assessment.duration}</span>
              <Button
                variant={isLocked ? 'secondary' : 'primary'}
                disabled={isLocked}
                onClick={() => navigate('/tutor')}
              >
                {isLocked ? '未解锁' : '开始诊断'}
                {!isLocked ? <ArrowRight size={16} aria-hidden="true" /> : null}
              </Button>
            </article>
          )
        })}
      </section>
    </div>
  )
}
